import { render, staticRenderFns } from "./SubScription.vue?vue&type=template&id=20cc3b5d&"
import script from "./SubScription.vue?vue&type=script&lang=js&"
export * from "./SubScription.vue?vue&type=script&lang=js&"
import style0 from "./SubScription.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports